
<template>
  <div
    class="d-flex flex-column h-100 px-3"
    style="overflow: auto; min-width: 50vw; min-height: 50vh"
  >
    <div class="d-flex flex-column pt-3 pb-3 justify-content-center">
      <h2 class="d-flex justify-content-center mb-3">
        {{
          (!otp_key ? $t("otp.title_create") + " " : "") + $t("otp.title_scan")
        }}
      </h2>

      <div
        class="d-flex flex-column justify-content-center align-items-center"
        v-if="qrOTP && otp_key"
      >
        <qrcode-vue
          style=""
          class="qr-code"
          :value="qrOTP"
          :size="400"
          level="H"
          background="white"
          foreground="black"
        />
      </div>

      <div
        class="d-flex flex-row justify-content-center w-100 mt-3"
        style="flex-wrap: wrap; gap: 20px"
      >
        <base-button
          v-if="entity && id"
          :variant="'pure'"
          className="v-btn v-theme--ORANGE_THEME bg-success v-btn--density-default v-btn--size-default v-btn--variant-flat"
          @click="askRegenerate"
        >
          <h2 v-if="otp_key">{{ $t("otp.btn.reCreate") }}</h2>
          <h2 v-if="!otp_key">{{ $t("otp.btn.create") }}</h2>
        </base-button>

        <base-button
          v-if="otp_key"
          :variant="'pure'"
          className="v-btn v-theme--ORANGE_THEME bg-error v-btn--density-default v-btn--size-default v-btn--variant-flat"
          @click="deleteOTP"
        >
          <h2>{{ $t("otp.btn.remove") }}</h2>
        </base-button>
      </div>
    </div>

    <spinner v-if="spinnerShow"></spinner>
    <BaseDialog :modelValue="showDialogue">
      <h2 class="d-flex">
        {{ dialogueMessage }}
      </h2>
      <div
        class="d-flex flex-row justify-content-center"
        style="flex-wrap: wrap; gap: 20px"
      >
        <base-button
          :variant="'pure'"
          className="v-btn v-theme--ORANGE_THEME bg-success v-btn--density-default v-btn--size-default v-btn--variant-flat"
          @click="_confirm"
        >
          <h2>{{ okButton }}</h2>
        </base-button>

        <base-button
          :variant="'pure'"
          className="v-btn v-theme--ORANGE_THEME bg-error v-btn--density-default v-btn--size-default v-btn--variant-flat"
          @click="_cancel"
        >
          <h2>{{ cancelButton }}</h2>
        </base-button>
      </div>
    </BaseDialog>
  </div>
</template>


<script>
import BaseButton from "@/components/BaseButton.vue";
import Spinner from "../Spinner.vue";
import QrcodeVue from "qrcode.vue";
import BaseDialog from "@/components/BaseDialog.vue";
import EntityApi from "@/api/entityApi";

export default {
  name: "oneTimePassword-page",
  props: {
    id: {
      type: [Number, String],
      required: false,
    },
    entity: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
    },
  },
  emits: ["closeModalf", "updatedData"],
  components: {
    BaseButton,
    Spinner,
    QrcodeVue,
    BaseDialog,
  },
  data() {
    return {
      spinnerShow: false,
      otp_key: "",
      qrOTP: "",

      showDialogue: false,
      dialogueMessage: "",
      okButton: "",
      cancelButton: "",
      resolvePromise: undefined,
      rejectPromise: undefined,
    };
  },
  methods: {
    deleteOTP() {
      let url = `${process.env.VUE_APP_API_URL}/api/v1/admin_panel/entity/${this.entity}/${this.id}`;

      this.show({
        message: this.$t("otp.askRemove", {
          name: this.data?.name ? this.data.name : "user",
        }),
        okButton: this.$t("otp.yes"),
        cancelButton: this.$t("otp.no"),
      }).then((data) => {
        if (data) {
          EntityApi.sendCustomRequest(url, "put", { otp_secret_key: "" })
            .then(() => {
              this.spinnerShow = false;
              this.qrOTP = "";
              this.otp_key = "";
              this.$emit("updatedData", { otp_secret_key: "" });
            })
            .catch(() => {
              this.spinnerShow = false;
            });
        }
      });
    },
    askRegenerate() {
      if (this.otp_key) {
        this.show({
          message: this.$t("otp.askRegen"),
          okButton: this.$t("otp.yes"),
          cancelButton: this.$t("otp.no"),
        }).then((data) => {
          if (data) {
            this.getOTP();
          }
        });
      } else {
        this.getOTP();
      }
    },
    getOTP() {
      // this.entity this.id
      this.spinnerShow = true;

      let url = `${process.env.VUE_APP_API_URL}/api/auth/update_otp_secret_key?entity=${this.entity}&instance_id=${this.id}`;
      EntityApi.sendCustomRequest(url, "post", null)
        .then((resp) => {
          this.spinnerShow = false;
          if (resp && Object.keys(resp).length && resp.url && resp.secret_key) {
            this.otp_key = resp.secret_key;
            this.qrOTP = resp.url;
            this.$emit("updatedData", { otp_secret_key: resp.secret_key });
          }
        })
        .catch(() => {
          this.spinnerShow = false;
        });
    },
    getUrlOtp() {
      if (!this.entity || !this.id) {
        console.warn(
          "Entity or ID is not provided for OTP URL generation. Entity: ",
          this.entity,
          " / Instance id: ",
          this.id
        );

        return;
      }

      this.spinnerShow = true;
      let url = `${process.env.VUE_APP_API_URL}/api/auth/otp_secret_key_url?entity=${this.entity}&instance_id=${this.id}`;
      EntityApi.sendCustomRequest(url, "get", null)
        .then((resp) => {
          this.spinnerShow = false;
          if (resp && typeof resp == "string" && resp.length) {
            this.qrOTP = resp;
          }
        })
        .catch(() => {
          this.spinnerShow = false;
        });
    },
    show(opts = {}) {
      this.dialogueMessage = opts?.message ? opts.message : "Are you sure?";
      this.okButton = opts?.okButton ? opts.okButton : "Yes";
      this.cancelButton = opts?.cancelButton ? opts.cancelButton : "No";

      this.showDialogue = true;

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    _confirm() {
      this.showDialogue = false;
      this.resolvePromise(true);
    },
    _cancel() {
      this.showDialogue = false;
      this.resolvePromise(false);
    },
  },
  provide() {
    return {
      updateModelValue: null,
      validateAllField: null,
      setError: null,
      clearValidationErrors: null,
      clearValidationErrorsForField: null,
    };
  },
  mounted() {
    if (this.data && this.data.otp_secret_key) {
      this.otp_key = this.data.otp_secret_key;
      this.getUrlOtp();
    }
  },
  beforeUnmount() {},
  sockets: {},
  computed: {},
  watch: {
    "data.otp_secret_key": {
      handler(val, prevVal) {
        if (val != prevVal) {
          this.otp_key = val;
          this.getUrlOtp();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.qr-code {
  border-width: 5px;
  border-color: white;
  border-style: solid;
}
</style>